import * as React from 'react';
import './ALDropdown.scss';
import ProductModel from 'src/model/product.model';
import Button from 'src/components/common/Button';
import ListModel from 'src/model/list.model';
import { CartItemModel } from 'src/model/cartItem.model';
import { whiteSpacesValidation as hasWhiteSpaces } from 'src/utils/whiteSpacesValidation';
import env from 'src/shared/env';

enum ALDropdownState {
  List, // Normal list state
  Added, // On add success
  Error, // On error
  Edit // For creating a new list
}

export interface IALDropdownProps {
  part: ProductModel | CartItemModel;
  direction?: 'top' | 'bottom';
  lists: ListModel[];
  error: string;
  isLoading: boolean;
  isLoggedIn: boolean;
  favorite?: boolean;
  onSelect: (
    list: ListModel,
    part: ProductModel | CartItemModel,
    callback: (err?: any) => void
  ) => void;
  onCreate: (
    name: string,
    callback: (err: any, newList: ListModel) => void
  ) => void;
  clearError: () => void;
  reloadOrigin: () => void;
  t?: any;
}

export interface IALDropdownState {
  addedTo: ListModel;
  state: ALDropdownState;
  newListName: string;
}

export class ALDropdown extends React.Component<
  IALDropdownProps,
  IALDropdownState
> {
  public state: IALDropdownState = {
    addedTo: null,
    state: ALDropdownState.List,
    newListName: ''
  };

  private editInputRef: HTMLElement;

  public componentDidMount() {
    this.props.clearError();
    // if (this.props.error) {
    //   this.setState({
    //     state: ALDropdownState.Error
    //   });
    // }
  }

  public componentDidUpdate(prevProps: IALDropdownProps) {
    if (prevProps.error !== this.props.error) {
      if (this.props.error) {
        this.setState({
          state: ALDropdownState.Error
        });
      }
    }
  }

  private handleSelect = (list: ListModel) => {
    this.setState({
      state: ALDropdownState.List
    });
    this.props.onSelect(list, this.props.part, err => {
      if (err) {
        console.error(err);
        return;
      }
      this.setState(
        {
          state: ALDropdownState.Added,
          addedTo: list
        },
        () => (this.props.reloadOrigin ? this.props.reloadOrigin() : null)
      );
    });
  };

  private handleCreate = () => {
    this.props.onCreate(this.state.newListName, (err, newList) => {
      if (err) {
        console.error(err);
        return;
      }
      this.handleSelect(newList);
    });
  };

  private handleNewList = () => {
    this.setState(
      {
        state: ALDropdownState.Edit,
        newListName: ''
      },
      () => {
        if (this.editInputRef) {
          this.editInputRef.focus();
        }
      }
    );
  };

  private handleNewListNameChange = (
    event: React.FormEvent<HTMLInputElement>
  ) => {
    this.setState({ newListName: event.currentTarget.value });
  };

  private getVerboseError = (): string => {
    const { t } = this.props;
    let error = `${t('common.couldntAddtoList')}`;
    if (this.props.error.toLowerCase().includes('already exists')) {
      error = `${t('common.productalreadyOnListError')}`;
    }
    return error;
  };

  private renderHeader = () => {
    const state = this.state.state;
    const { t } = this.props;
    return (
      <div className="rp-aldropdown--header">
        {state === ALDropdownState.List ? (
          <div className="rp-dropdown--list">
            <span>{t('product.addTo')}:</span>
          </div>
        ) : state === ALDropdownState.Added ? (
          <div className="rp-dropdown--added">
            <i className="rpds rpds-check-circle" />
            <span>
              {t('product.addedTo')}{' '}
              {this.state.addedTo.name === 'Favorites' &&
              env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                ? 'Favourites'
                : this.state.addedTo.name}
            </span>
          </div>
        ) : state === ALDropdownState.Error ? (
          <div className="rp-dropdown--error">
            <i className="rpds rpds-error" />
            <span>{this.getVerboseError()}</span>
          </div>
        ) : state === ALDropdownState.Edit ? (
          <div className="rp-dropdown--edit">
            <input
              type="text"
              className="rp-dropdown--edit-input"
              ref={input => {
                this.editInputRef = input;
              }}
              value={this.state.newListName}
              onChange={this.handleNewListNameChange}
            />
            <Button
              buttonClass="primary-button rp-dropdown--edit-button"
              label={t('common.create')}
              textTransform="uppercase"
              width="96px"
              height="46px"
              action={this.handleCreate}
              disabled={hasWhiteSpaces(this.state.newListName)}
            />
          </div>
        ) : null}
      </div>
    );
  };

  private renderList = () => {
    return (
      <div className="rp-aldropdown--list">
        {this.props.lists.map((list, i) => (
          <button
            key={i}
            type="button"
            className="rp-aldropdown--list-item"
            onClick={() => this.handleSelect(list)}
            disabled={this.props.isLoading}
          >
            {list.favorite ? (
              <i
                className={
                  this.props.favorite
                    ? 'star rpds rpds-star yellow'
                    : 'star rpds rpds-star-border'
                }
              />
            ) : (
              <i className="rpds rpds-list" />
            )}
            <span>
              {list.name === 'Favorites' &&
              env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                ? 'Favourites'
                : list.name}
            </span>
            {console.log(list, 'listitems')}
          </button>
        ))}
      </div>
    );
  };

  private renderAddButton = () => {
    const { t } = this.props;
    return (
      <button
        type="button"
        className="rp-aldropdown--add-button"
        onClick={this.handleNewList}
        disabled={this.props.isLoading}
      >
        <i className="rpds rpds-add" />
        <span>{t('myFavourites.createNewList')}</span>
      </button>
    );
  };

  private renderLogIn = () => {
    const { t } = this.props;
    return (
      <div className="rp-aldropdown--login">
        {t('myFavourites.signinToSeeList')}
      </div>
    );
  };

  public render() {
    let extraclass = '';
    if (this.props.direction === 'top') {
      extraclass = 'top';
    }
    return (
      <div className={`rp-aldropdown ${extraclass}`}>
        <div className="rp-aldropdown--container">
          {this.renderHeader()}
          {this.props.isLoggedIn ? (
            <React.Fragment>
              {this.renderList()}
              {this.renderAddButton()}
            </React.Fragment>
          ) : (
            this.renderLogIn()
          )}
        </div>
        {this.props.isLoading ? (
          <div className="rp-aldropdown--loading" />
        ) : null}
      </div>
    );
  }
}
